export default {
  title: {
    id: 'hyperwallet_transfer_methods',
    defaultMessage: 'Transfer methods',
  },
  subtitle: {
    id: 'hyperwallet_transfer_methods_subtitle',
    defaultMessage:
      'Back Market is working closely with Hyperwallet to gather your business information safely. {link, html}',
  },
  learnMoreAboutHyperwallet: {
    id: 'hyperwallet_transfer_methods_learn_more_link',
    defaultMessage: 'Learn more about Hyperwallet.',
  },
  loadingText: {
    id: 'hyperwallet_loading_text',
    defaultMessage:
      'Please wait while we reach out to our friends at Hyperwallet',
  },
  alreadyConfigured: {
    id: 'hyperwallet_transfer_methods_already_configured',
    defaultMessage: 'You already have your transfer methods configured',
  },
  hWErrorToastContent: {
    id: 'hyperwallet_kyb_error_toast_content',
    defaultMessage:
      'There is an error creating your account, please contact your SSM.',
  },
}
